import promotional from "../../services/promotional";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    promoCodeDetails: null,
  },
  mutations: {
    loading(state, value = true) {
      state.loading = value;
    },
    errors(state, errors) {
      state.errors = errors;
    },
    resetErrors(state) {
      state.errors = null;
    },
    promoCodeDetails(state, details) {
      state.promoCodeDetails = details;
    },
  },
  getters: {
    promoCodeDetails: state => state.promoCodeDetails,
    promoErrors: state => state.errors,
  },
  actions: {
    async resetErrors({ commit }) {
        commit("resetErrors");
    },
    async verifyPromoCode({ commit }, payload) {
      commit("loading", true);
      commit("resetErrors");
      commit("promoCodeDetails", null);

      try {
        const { data } = await promotional.verifyPromoCode(payload);
        commit("promoCodeDetails", data);
      } catch (errors) {
        commit("errors", errors);
      } finally {
        commit("loading", false);
      }
    }
  }
};
